<ng-container *transloco="let t; read: 'LIKE_FILTER_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <div class="spacer"></div>
    </div>
  </ion-toolbar>

  <ion-content class="ion-padding">
    <div class="title">{{ t('TITLE') }}</div>
    <app-select mode="checklist" [formControl]="filterCtrl" class="fade-in mt-8" *ngIf="filterOptions" [options]="filterOptions" [hideBackground]="true">
    </app-select>
    <div class="spacer"></div>
    <ion-button [disabled]="filterCtrl.invalid" (click)="validate()">{{ t('VALIDATE') }}</ion-button>
  </ion-content>
</ng-container>
